import { Box, Icon } from '@rbilabs/universal-components';

export const PaymentMethodSelect = Box.withConfig({
  backgroundColor: Styles.color.cardBackground,
  borderWidth: 1,
  borderColor: Styles.color.grey.four,
  borderRadius: Styles.borderRadius,
});

export const StyledAddNewCreditCardIcon = Icon.withConfig({
  variant: 'emptyCreditCard',
});

export const StyledAddPaymentMethodIcon = Icon.withConfig({ variant: 'addCard' });

export const ToggleWrapper = Box.withConfig({
  position: 'absolute',
  top: '$4',
  right: '$2',
});
